'use strict';

$(function(){
  let $windowWidth = $(window).width();
  let $bodyHtml = $('body,html');
  let $html = $('html');
  let $body = $('body');
  let breakPoint1 = 768;

  //スムーススクロール
  $('a[href^="#"]').on('click', function() {
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top;
    let headerHeight = $('header').innerHeight() + 50;
    $bodyHtml.animate({scrollTop:position - headerHeight}, 500, 'swing');
    return false;
  })

  //SubMenu
  $('.l-header__solution__list').hide();
  $(window).on('load', function(){
    $('.l-header__solution__list').show();
  })
  $('.l-header__solution').on('click', function(){
    $('.l-header__solution__list').toggleClass('active');
  })
  $('.l-header__solution__list a').on('click', function(){
    $('.l-header__solution').click();
  })

  //SP Menu
  if($windowWidth < breakPoint1){
    $('.sp__nav').on('click', function(){
      $('.l-header__right').toggleClass('active');
      $(this).toggleClass('active');
    })
    $('.l-header__solution').on('click', function(){
      $('.l-header__solution__list').slideToggle();
    })
    $('.l-header__right a').on('click', function(){
      $('.sp__nav').click();
    })
  }

  //to TOP
  $(window).scroll(function () {
    let docH = $(document).innerHeight();
    let winH = $(window).innerHeight();
    let bottom = docH - winH;
    if($(this).scrollTop() >= bottom - 100){
    $('.c-toTop').removeClass('active');
    } else if ($(this).scrollTop() > 300) {
      $('.c-toTop').addClass('active');
    } else {
      $('.c-toTop').removeClass('active');
    }
  })

  //modal
  $('.modal__bg').hide();
  $(window).on('load', function(){
    $('.modal__bg').show();
  })
  $('.modal__open').on('click', function(){
    $(this).next('.modal__bg').addClass('active');
    $('body').css('overflow-y', 'hidden');
  })
  $('.modal__close').on('click', function(){
    $(this).parent('.modal__bg').removeClass('active');
    $('body').css('overflow-y', 'auto');
  })

})
